import React from "react";
import { CreateContainer } from "~/Containers/ContainerCreate";
import { getTopChimneys } from "~/api/getStats";

class TopChimneysContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const chims = (data && data.data) || {};
    return render({ chims, loading, failure });
  };
}

export default CreateContainer(getTopChimneys, TopChimneysContainer);
